import {
  BarChart3,
  User,
  Target,
  Briefcase,
  Rocket,
  Megaphone,
  Calculator,
  FolderPlus,
  LayoutGrid,
} from 'lucide-react';

export interface ArtifactReference {
  type: string;
  recordId: string;
  status: 'completed' | 'failed';
  summary?: string;
}

export const ARTIFACT_CONFIG: Record<string, {
  icon: typeof BarChart3;
  labelKey: string;
  path: string;
  color: string;
}> = {
  market_analysis: {
    icon: BarChart3,
    labelKey: 'artifact.labels.market_analysis',
    path: '/market-analysis',
    color: 'text-blue-500',
  },
  persona: {
    icon: User,
    labelKey: 'artifact.labels.persona',
    path: '/personas',
    color: 'text-purple-500',
  },
  positioning: {
    icon: Target,
    labelKey: 'artifact.labels.positioning',
    path: '/positioning',
    color: 'text-orange-500',
  },
  business_model: {
    icon: Briefcase,
    labelKey: 'artifact.labels.business_model',
    path: '/business-model',
    color: 'text-green-500',
  },
  mvp_plan: {
    icon: Rocket,
    labelKey: 'artifact.labels.mvp_plan',
    path: '/mvp-plan',
    color: 'text-red-500',
  },
  marketing_strategy: {
    icon: Megaphone,
    labelKey: 'artifact.labels.marketing_strategy',
    path: '/marketing-strategy',
    color: 'text-pink-500',
  },
  financial_model: {
    icon: Calculator,
    labelKey: 'artifact.labels.financial_model',
    path: '/financial-model',
    color: 'text-emerald-500',
  },
  methodology: {
    icon: LayoutGrid,
    labelKey: 'artifact.labels.methodology',
    path: '/methods',
    color: 'text-sky-500',
  },
  project: {
    icon: FolderPlus,
    labelKey: 'artifact.labels.project',
    path: '/projects',
    color: 'text-indigo-500',
  },
};

// Типы артефактов, у которых есть текстовое содержимое для боковой панели.
// Проект — просто ссылка на страницу проектов, панель для него не открываем.
export const PANEL_SUPPORTED_TYPES = new Set([
  'market_analysis',
  'persona',
  'positioning',
  'business_model',
  'mvp_plan',
  'marketing_strategy',
  'financial_model',
  'methodology',
]);

// Research methodologies live as tabs on /research, the rest on /methods/:id.
const RESEARCH_METHODS = new Set(['custdev-questions', 'survey', 'research-analysis']);

export function methodologyPagePath(method: string, recordId: string): string {
  const id = encodeURIComponent(method);
  const record = encodeURIComponent(recordId);
  return RESEARCH_METHODS.has(method)
    ? `/research?tab=${id}&recordId=${record}`
    : `/methods/${id}?recordId=${record}`;
}
